import React from "react";
import data from '../data/data'
function Footer() {
  // get current year
  const currentYear = new Date().getFullYear();
  
  const fullName = `${data[0]?.profile?.firstName} ${data[0]?.profile?.lastName}`;
  return (
    <section id="footer">
      <footer className="rounded-lg shadow m-4 bg-indigo-600">
        <div className="w-full mx-auto max-w-screen-xl p-4 md:flex md:items-center md:justify-center font-montserrat">
          <span className="text-md sm:text-center text-white">
            © {currentYear}{" "}
            <a href="/" className="hover:underline">
              Made with ❤️ By {fullName}
            </a>
            . All Rights Reserved.
          </span>
          {/* <ul className="flex flex-wrap items-center mt-3 text-md font-medium text-white dark:text-white sm:mt-0">
            <li>
              <a href="/" className="hover:underline me-4 md:me-6">
                About
              </a>
            </li>
            <li>
              <a href="/" className="hover:underline me-4 md:me-6">
                Projects
              </a>
            </li>
            <li>
              <a href="/" className="hover:underline">
                Contact
              </a>
            </li>
          </ul> */}
        </div>
      </footer>
    </section>
  );
}

export default Footer;
